import { faCode } from '@fortawesome/pro-solid-svg-icons';
import {
  GenericSelectorModalConfig,
  GenericNodeComponentConfig,
} from '../shared';

/**
 * Code item interface for ui_metadata storage
 */
export interface CodeItem {
  id: string;
  displayLabel: string;
  code_name: string;
  category?: string;
}

/**
 * Transform API response to CodeItem format
 */
export const transformCode = (apiItem: {
  code_name: string;
  category?: string;
}): CodeItem => ({
  id: apiItem.code_name,
  displayLabel: apiItem.code_name,
  code_name: apiItem.code_name,
  category: apiItem.category,
});

/**
 * Modal configuration for Code selector
 */
export const codeModalConfig: GenericSelectorModalConfig<CodeItem> = {
  title: 'Select Codes',
  searchPlaceholder: 'Search codes, descriptions, or categories...',
  emptyStateIcon: faCode,
  emptyStateMessage: 'No codes selected',
  noResultsMessage: (searchTerm) => `No codes found for "${searchTerm}"`,
  colorTheme: 'green',
  selectionMode: 'multiple',
  showConnectorToggle: true,
  defaultConnector: 'ANY',
  getItemLabel: (item) => item.code_name,
  getItemSecondaryLabel: (item) => item.category || null,
  getItemKey: (item) => item.id,
  isItemSelected: (item, selectedItems) =>
    selectedItems.some((s) => s.id === item.id),
  itemLabel: 'code',
  itemLabelPlural: 'codes',
};

/**
 * Node display configuration for Code
 */
export const codeNodeConfig: GenericNodeComponentConfig<CodeItem> = {
  colorTheme: 'green',
  getItemLabel: (item) => item.code_name,
  getItemKey: (item) => item.id,
  maxVisibleItems: 2,
  showConnectorLabel: true,
};
